/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RealmEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_REALM_EVENT_ENTITY_NAME = 'ixm.userauth.v1.RealmEvent';
export const ixmUserauthV1RealmEventEntity = new schema.Entity<IxmUserauthV1RealmEvent>(IXM_USERAUTH_V1_REALM_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1RealmEvent) => `${entity.metadata?.eventId}` });

